import { ReactNode } from 'react';
import { AghanimIcon } from '../../icons';

export const isAghanimIcon = (icon: { type: string } | ReactNode) => {
  const _icon = icon as AghanimIcon;
  return _icon.type === 'aghanim-icon' || (icon as { type: string }).type === 'svg';
};
